<template>
  <h1
    :style="{
      color: siteSettings.headingColor,
      fontSize: siteSettings.headingSize
    }"
    v-html="text"
  ></h1>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Heading",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(["siteSettings"])
  }
};
</script>

<style lang="scss"></style>
